<script>
  import Login from "./screens/Login.svelte";
  import Register from "./screens/Register.svelte";
  import EnviarArticulo from "./screens/EnviarArticulo.svelte";
  import EnviarArticuloOk from "./screens/EnviarArticuloOk.svelte";
  import Usuarios from "./screens/Usuarios.svelte";
  import HistorialEditor from "./screens/HistorialEditor.svelte";
  import HistorialRevisor from "./screens/HistorialRevisor.svelte";
  import HistorialArticulo from "./screens/HistorialArticulo.svelte";
  import Cuenta from "./screens/Cuenta.svelte";
  import ArticulosEditor from "./screens/ArticulosEditor.svelte";
  import ArticulosRevisor from "./screens/ArticulosRevisor.svelte";
  import ArticulosAutor from "./screens/ArticulosAutor.svelte";
  import Articulo from "./screens/Articulo.svelte";
  import RememberPassword from "./screens/RememberPassword.svelte";
  import Legal from "./screens/Legal.svelte";

  import { Router, Link, Route } from "svelte-routing";

  export let url = "";
</script>

<Router {url}>
  <Route path="/login">
    <Login />
  </Route>
  <Route path="/register">
    <Register />
  </Route>
  <Route path="/enviar-articulo">
    <EnviarArticulo />
  </Route>
  <Route path="/enviar-articulo/:id" let:params>
    <EnviarArticulo id={params.id} />
  </Route>
  <Route path="/enviar-articulo-ok">
    <EnviarArticuloOk />
  </Route>
  <Route path="/usuarios">
    <Usuarios />
  </Route>
  <Route path="/historial-editor/:id" let:params>
    <HistorialEditor id={params.id} />
  </Route>
  <Route path="/historial-revisor/:id" let:params>
    <HistorialRevisor id={params.id} />
  </Route>
  <Route path="/historial-articulo/:id" let:params>
    <HistorialArticulo id={params.id} />
  </Route>
  <Route path="/cuenta">
    <Cuenta />
  </Route>
  <Route path="/cuenta/:id" let:params>
    <Cuenta id={params.id} />
  </Route>
  <Route path="/articulos-editor">
    <ArticulosEditor />
  </Route>
  <Route path="/articulos-revisor">
    <ArticulosRevisor />
  </Route>
  <Route path="/articulos-autor">
    <ArticulosAutor />
  </Route>
  <Route path="/articulo/:id" let:params>
    <Articulo id={params.id} />
  </Route>
  <Route path="/remember-password">
    <RememberPassword />
  </Route>
  <Route path="/legal">
    <Legal />
  </Route>
  <Route path="/">
    <Login />
  </Route>
</Router>
